import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

import currentUser from '../../store/currentUser';


export const permissionType = PropTypes.oneOfType([
  PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.string),
]);


class PermissionChecker extends React.Component {
  static propTypes = {
    permission: permissionType,
    placement: PropTypes.string,
  };

  static defaultProps = {
    permission: true,
    placement: 'bottom',
  };

  render() {
    const { permission, placement, children } = this.props;
    let hasPermission = permission;
    if (typeof permission !== 'boolean') {
      const permissions = Array.isArray(permission) ? permission : [permission];
      hasPermission = permissions.some(permission => currentUser.can(permission));
    }
    const content = children instanceof Function ? children(hasPermission) : children;
    if (hasPermission) {
      return content;
    }

    return (
      <Tooltip title="You do not have the permission to do this" placement={placement}>
        <span>{content}</span>
      </Tooltip>
    );
  }
}


export default PermissionChecker;
